<template>
  <div class="container-fluid">
    <template v-if="product">
      <div class="d-flex align-items-center my-2">
        <back-button class="mr-2" to="/settings/recipes/products"/>
        <div class="input-group mr-2 name-input">
          <input type="text" class="form-control" v-model="product.name">
        </div>
        <div class="custom-control custom-checkbox">
          <input class="custom-control-input" v-model="product.piece" type="checkbox" value="" :id="`checkbox-piece`">
          <label class="custom-control-label" :for="`checkbox-piece`">Штучный продукт</label>
        </div>
        <button class="btn btn-primary mr-2 ml-auto" @click="addIngredient" :disabled="product.piece">Добавить ингредиент</button>
        <btn-action class="btn btn-primary mr-2" @click="save" v-if="$root.checkPermission('web_recipes_edit')">
          Сохранить
        </btn-action>
      </div>
      <div class="table-full-width">
        <table class="table">
          <thead>
          <tr>
            <th>Ингредиент</th>
            <th colspan="2">Количество</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(component, index) in product.components">
            <td v-if="component.component">{{ component.component.name }}</td>
            <td v-else>
              <small><samp
                class="text-muted"
                data-title="Некорректная ссылка"
                data-toggle="tooltip"
                data-placement="right"
              >
                {{component.component_id}}
              </samp></small>
            </td>
            <amount-input
              :measure="component.component.measure"
              v-model="component.amount"
            />
            <td>
              <button class="btn btn-outline-light" @click="removeComponent(index)">Удалить</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import BtnAction from '../../../../components/btn-action'
  import productModal from '../../../../components/recipes/product-modal.vue'
  import AmountInput from '../../../../components/recipes/amount-input'

  export default {
    components: { AmountInput, BtnAction },
    props: {
      id: null,
    },
    metaInfo () {
      const productName = this.product ? this.product.name : ''
      return { title: `Рецептура ${productName}` }
    },
    data () {
      return {}
    },
    methods: {
      removeComponent (index) {
        this.product.components.splice(index, 1)
      },
      addIngredient () {
        this.$root.showModal(productModal).then((data) => {
          if (data) {
            this.product.components.push({
              amount: 0,
              component: data.component,
            })
          }
        })
      },
      save () {
        const data = {
          components: this.product.components.map(component => {
            return {
              amount: component.amount,
              component_id: component.component.id,
            }
          }),
          name: this.product.name,
          piece: this.product.piece,
        }
        if (this.id) {
          api.put(`products/${this.id}`, data)
            .then(() => this.$router.push(`/settings/recipes/products`))
        } else {
          api.post('products', data).then(() => this.$router.push(`/settings/recipes/products`))
        }
      },
    },
    asyncComputed: {
      product () {
        if (this.id) {
          return api.get(`products/${this.id}`)
            .then(({data}) => data.data)
        } else {
          return {
            components: [],
            name: 'Новый продукт',
            piece: false,
          }
        }
      },
    },
    watch: {
      'product.piece': function () {
        if (this.product.piece) {
          this.product.components = []
        }
      },
    },
  }
</script>
<style lang="scss">
  .name-input {
    max-width: 30em !important;
  }
  .amount-input {
    max-width: 10em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/products/_id.vue